import React from "react";

import { JwtContext } from "./JwtContext";

interface Props {
  children: React.ReactNode;
}

export const JwtProvider = (props: Props) => {
  const jwtState = React.useRef<string | null>(localStorage["jwt"] ?? null);

  const setJwt = React.useCallback((jwt: string) => {
    jwtState.current = jwt;
    localStorage["jwt"] = jwt;
  }, []);

  const getJwt = React.useCallback(() => {
    return jwtState.current!;
  }, [jwtState]);

  const getJwtOrNull = React.useCallback(() => {
    return jwtState.current;
  }, [jwtState]);

  const contextValue = React.useMemo(
    () => ({ setJwt, getJwt, getJwtOrNull }),
    [setJwt, getJwt, getJwtOrNull]
  );

  return (
    <JwtContext.Provider value={contextValue}>
      {props.children}
    </JwtContext.Provider>
  );
};
